import React, { FC } from 'react';
import { useTranslations } from '@lang';
import {
  QuantityPickerWrapper,
  IconButton,
  MinusCircleIcon,
  QuantityValue,
  PlusCircleIcon,
} from './QuantityPicker.styles';

type QuantityPickerProps = {
  input: {
    value: number;
    onChange: (value: number) => void;
  };
  maxValue?: number;
  minValue?: number;
  isDisabled?: boolean;
  isSmall?: boolean;
  incrementBy?: number;
  controlId?: string;
  showZeroCounter?: boolean;
};

export const QuantityPicker: FC<QuantityPickerProps> = ({
  input: { value, onChange },
  minValue = 1,
  maxValue = Infinity,
  isDisabled = false,
  isSmall = true,
  incrementBy = 1,
  controlId,
  showZeroCounter,
}) => {
  const { t } = useTranslations();
  const parsedValue = value || minValue;
  return maxValue === 1 && !showZeroCounter ? null : (
    <QuantityPickerWrapper data-testid="quantity-picker">
      <IconButton
        type="button"
        onClick={() => onChange(parsedValue - incrementBy)}
        disabled={isDisabled || parsedValue <= minValue || parsedValue - incrementBy < minValue}
        aria-label="-1"
      >
        <MinusCircleIcon small={isSmall} />
      </IconButton>
      <QuantityValue
        value={parsedValue}
        aria-label={t('aria.basketQuantityValue')}
        onChange={({ target }) => onChange(Number.parseInt(target.value, 10))}
        data-testid="quantityInput"
        id={controlId}
      />
      <IconButton
        type="button"
        onClick={() => onChange(parsedValue + incrementBy)}
        aria-label="+1"
        disabled={isDisabled || parsedValue >= maxValue || parsedValue + incrementBy > maxValue}
      >
        <PlusCircleIcon small={isSmall} />
      </IconButton>
    </QuantityPickerWrapper>
  );
};
